module.exports = __webpack_public_path__ + "img/icon_top_104.a611ab72.svg";